<template>
  <InvoiceCardSkeleton v-if="loading" />
  <div v-else class="invoice-content">
    <div class="invoice-content-item">
      <p class="sub-title">Fatura Yükleme Oranı</p>
      <TooltipPlugin
        :position="position"
        :tooltipText="tooltipText"
        :tooltipWidth="tooltipWidth"
        :showArrow="showArrow"
        :tooltipImage="tooltipImage"
        :offset="offsetTooltipImage"
      >
        <template #tooltip-btn>
          <Icons
            name="InfoCircle"
            xs
            :class="[{ 'tooltip-icon': tooltipImage }]"
            color="#4E5C78"
          />
        </template>
        <template #tooltip-content v-if="tooltipImage">
          <img
            :src="tooltipImage"
            alt="tooltip_image"
            class="tooltip-image"
          />
        </template>
      </TooltipPlugin>
    </div>
    <ColoredProgressBar :percent="invoiceData?.uploadedInvoiceRate" />
    <div class="invoice-content-item-body" @click="goToLink">
  <div class="top-content-item">
    <p class="sub-title">Yüklemeniz Gereken Fatura</p>
    <TooltipPlugin
      :position="position"
      :tooltipText="tooltipTextOther"
      :tooltipWidth="tooltipWidthOther"
      :showArrow="showArrow"
      :tooltipImage="tooltipImage"
      :offset="offsetTooltipImage"
    >
      <template #tooltip-btn>
        <Icons
          name="InfoCircle"
          xs
          :class="[{ 'tooltip-icon': tooltipImage }]"
          color="#4E5C78"
        />
      </template>
      <template #tooltip-content v-if="tooltipImage">
        <img
          :src="tooltipImage"
          alt="tooltip_image"
          class="tooltip-image"
        />
      </template>
    </TooltipPlugin>
  </div>
  <div class="invoice-content-item-sub-body">
    <strong>{{ invoiceData?.notUploadedInvoiceCount }}</strong>
    <DelayCard
      v-if="invoiceData?.notUploadedInvoiceCount > 0"
      :delayCount=invoiceData?.uploadDelayedInvoiceCount
      link="/selleroffice/order/orderManagement?invoiceStatus=UPLOAD_DELAYED "
      description="fatura gecikiyor"
    />
  </div>
</div>
<div class="invoice-content-footer">
    <p>Bilgiler 8 saatte bir güncellenir.</p>
    <p>Son Güncelleme Tarihi: {{ formatDashboardDate(invoiceData?.lastUpdatedDate) }}</p>
  </div>
</div>
  
</template>

<script setup>
import InvoiceCardSkeleton from '@/components/InvoiceCard/InvoiceCardSkeleton.vue';
import { TooltipPlugin, Icons } from '@n11/so-ui-components';
import ColoredProgressBar from '@/components/InvoiceCard/ColoredProgressBar.vue';
import DelayCard from '@/components/DelayCard/DelayCard.vue';
import { formatDashboardDate } from '@/utils/formatedDate';
import { ENVIRONMENT_HOSTS } from '@/utils/enum/enviromentHosts';

const TEST_SO_N11 = ENVIRONMENT_HOSTS.TEST_SO_N11;

defineProps({
  invoiceData: {
    type: Object,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  }
});

const position = 'bottom';
const tooltipText = 'Tamamlanan siparişlerinize ait yüklediğiniz faturaların oranını gösterir. Son 1 aydaki veridir.';
const tooltipTextOther = 'Yüklemeniz gereken faturaların sayısıdır. Tamamlanan siparişlerinizin faturalarını 7 gün içinde yüklemezseniz, “Gecikiyor” statüsünde gösterilir.';
const tooltipWidth = 294;
const tooltipWidthOther = 258;
const offsetTooltipImage = 0;
const showArrow = true;

const goToLink = () => {
  window.location.href = TEST_SO_N11 + '/selleroffice/order/orderManagement?invoiceStatus=NOT_UPLOADED';
};

</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';
@import '@/assets/styles/mobiles.scss';
@import '@/assets/styles/mobilesFooter.scss';
@import '@/assets/styles/card.scss';


.invoice-content-item {
  display: flex;
  gap: 8px;
  justify-content: flex-start;

  .sub-title {
    font-size: 14px;
    color: $colorN80;
    margin-bottom: 8px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px;
    letter-spacing: -0.05px;
  }
}

.invoice-content-item-body {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  flex: 1 0 0;
  background-color: $colorN00;
  width: 100%;
  height: 86px;
  border: 1px solid #D3D6DF;
  border-radius: 8px;
  margin-top: 8px;
  padding: 16px;
  cursor: pointer;

  .top-content-item {
    display: flex;
    gap: 8px;
    justify-content: flex-start;
    width: 100%;
    align-items: center;

    .sub-title {
      font-size: 13px;
      font-style: normal;
      font-weight: 600;
      line-height: 18px;
      /* 138.462% */
      letter-spacing: -0.05px;
      color: $colorN80;
    }
  }
}

.invoice-content-item-sub-body {
  display: flex;
  align-items: center;
  gap: 8px;

  strong {
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: 34px;
    letter-spacing: -0.4px;
  }
}


.invoice-content-footer {
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  /* 150% */
  color: #7382A0;
  margin-top: 12px;
}
</style>
